<template>
	<div class="page">
		<van-icon name="arrow-left" class="return" size="28" @click="goBack" />
		<div class="logo">
			<img src="../assets/images/logo.png" alt="" />
		</div>
		<div class="info">
			
			<div class="title">在线报名</div>
			<div class="text">请使用参会人员手机号进行报名，</div>
			<div class="text">以此作为进入会场的唯一凭证。</div>
			<div class="form">
				<div class="item">
					<div class="label">供应商9位数代码</div>
					<div class="input">
						<input type="text" v-model="supplierCode" />
					</div>
				</div>
				<div class="item">
					<div class="label">供应商名称（全称）</div>
					<div class="input">
						<input type="text" v-model="supplierName" />
					</div>
				</div>
				<div class="item">
					<div class="label">参会人员姓名1</div>
					<div class="input">
						<input type="text" v-model="participantName1" />
					</div>
				</div>
				<div class="item">
					<div class="label">职务</div>
					<div class="input">
						<input type="text" v-model="position1" />
					</div>
				</div>
				<div class="chose">
					<div class="item" style="flex: 0.3">
						<div class="label">性别</div>
						<div class="input">
							<select v-model="sex1" class="custom-select">
								<option value="1">男</option>
								<option value="2">女</option>
							</select>
						</div>
					</div>
					<div class="item" style="flex: 0.68">
						<div class="label">电话</div>
						<div class="input">
							<input type="text" v-model="mobile1" />
						</div>
					</div>
				</div>
				<div class="item" style="flex: 0.68">
					<div class="label">是否参加自助午餐</div>
					<div class="radio horizontal">
						<label>
							<input
								type="radio"
								value="1"
								v-model="isJoinBuffet1"
							/>
							<span>是</span>
						</label>
						<label>
							<input
								type="radio"
								value="2"
								v-model="isJoinBuffet1"
							/>
							<span>否</span>
						</label>
					</div>
				</div>
				<div class="item">
					<div class="label">参会人员姓名2（选填）</div>
					<div class="input">
						<input type="text" v-model="participantName2" />
					</div>
				</div>
				<div class="item">
					<div class="label">职务</div>
					<div class="input">
						<input type="text" v-model="position2" />
					</div>
				</div>
				<div class="chose">
					<div class="item" style="flex: 0.3">
						<div class="label">性别</div>
						<div class="input">
							<select v-model="sex2" class="custom-select">
								<option value="1">男</option>
								<option value="2">女</option>
							</select>
						</div>
					</div>
					<div class="item" style="flex: 0.68">
						<div class="label">电话</div>
						<div class="input">
							<input type="text" v-model="mobile2" />
						</div>
					</div>
				</div>
				<div class="item" style="flex: 0.68">
					<div class="label">是否参加自助午餐</div>
					<div class="radio horizontal">
						<label>
							<input
								type="radio"
								value="1"
								v-model="isJoinBuffet2"
							/>
							<span>是</span>
						</label>
						<label>
							<input
								type="radio"
								value="2"
								v-model="isJoinBuffet2"
							/>
							<span>否</span>
						</label>
					</div>
				</div>
			</div>
		</div>
		<div class="apply" @click="toApply">提交</div>
		<div v-if="loading" class="loading-overlay">
			<van-loading type="spinner" size="30px">提交中...</van-loading>
		</div>
	</div>
</template>

<script setup>
import { ref,watch } from "vue";
import { showToast, showSuccessToast } from "vant";
import { addInfo } from "../api/user";
import { useRouter } from "vue-router";

const router = useRouter();

const goBack = () => {
	router.back();
};


const loading = ref(false); // 添加 loading 状态

const supplierCode = ref("");
const supplierName = ref("");
const participantName1 = ref("");
const position1 = ref("");
const sex1 = ref();
const mobile1 = ref("");
const isJoinBuffet1 = ref();

const participantName2 = ref("");
const position2 = ref("");
const sex2 = ref();
const mobile2 = ref("");
const isJoinBuffet2 = ref();

// 监听电话1和电话2的变化
watch([mobile1, mobile2], ([newMobile1, newMobile2]) => {
  if (newMobile1 && newMobile1 === newMobile2) {
    showToast("两位参会人员的电话不能相同");
  }
});

const validateRequiredFields = () => {
	const errors = [];
	if (!supplierCode.value) {
		errors.push("供应商代码不能为空");
	} else if (!/^[a-zA-Z0-9]+$/.test(supplierCode.value)) {
		errors.push("供应商代码格式错误");
	}

	if (!supplierName.value) errors.push("供应商名称不能为空");
	if (!participantName1.value) errors.push("参会人员姓名1不能为空");
	if (!position1.value) errors.push("职务不能为空");
	if (!sex1.value) errors.push("性别不能为空");
	if (!isJoinBuffet1.value) errors.push("请选择是否参加自助午餐");
	if (!mobile1.value) {
		errors.push("电话不能为空");
	} else if (!/^1[3-9]\d{9}$/.test(mobile1.value)) {
		errors.push("电话格式不正确");
	}

	return errors;
};

const toApply = async () => {
	console.log(sex1.value);
	const errors = validateRequiredFields();
	for (const error of errors) {
		showToast(error);
		return; // 立即返回，确保每次只显示一条错误信息
	}

	if (
		participantName2.value ||
		position2.value ||
		mobile2.value ||
		isJoinBuffet2.value ||
		sex2.value == ""
	) {
		if (!participantName2.value || !position2.value || !mobile2.value) {
			showToast("请完整填写第二位参会人员的信息");
			return;
		}
	}

	if (mobile1.value === mobile2.value) {
		showToast("两位参会人员的电话不能相同");
		return;
	}

	loading.value = true; // 显示加载动画

	// 提交接口
	const res = await addInfo({
		supplierCode: supplierCode.value,
		supplierName: supplierName.value,
		participant1: {
			name: participantName1.value,
			position: position1.value,
			sex: sex1.value,
			mobile: mobile1.value,
			isJoinBuffet: isJoinBuffet1.value,
		},
		participant2: {
			name: participantName2.value,
			position: position2.value,
			sex: sex2.value,
			mobile: mobile2.value,
			isJoinBuffet: isJoinBuffet2.value,
		},
	});

	loading.value = false; // 隐藏加载动画

	if (res.code == 200) {
		showSuccessToast("报名成功");
		// 返回首页
		setTimeout(() => {
			router.push("/");
		}, 2000);
	} else {
		showToast(res.msg);
	}
};
</script>

<style scoped>
.page {
	width: 100vw;
	min-height: 100vh; /* 使用 min-height 代替 height */
	background: url("../assets/bg/background-3.jpg") 100% 100% no-repeat;
	background-size: cover;
	background-attachment: fixed; /* 固定背景 */
}
.logo img {
	width: 50%;
	height: auto;
	display: block;
	margin: 0 auto;
	padding-top: 10px;
}

.info {
	width: 82%;
	margin: auto;
	border-radius: 15px;
	margin-top: 10px;
	padding: 10px;
	background-color: rgb(2 174 250 / 20%);
	box-sizing: border-box;
}

.form {
	width: 100%;
	box-sizing: border-box;
}

.item {
	width: 100%;
	margin-top: 10px;
}

.title {
	text-align: center;
	color: #ffffff;
	font-weight: bold;
	font-size: 18px;
}

.text {
	text-align: center;
	color: #ffffff;
	font-size: 12px;
	margin-top: 5px;
}

.item .label {
	color: #ffffff;
	font-size: 14px;
	margin-bottom: 6px;
}

input {
	width: 100%;
	height: 28px;
	background: #ffffff00;
	border: none;
	border: 1px solid #02aefa;
	border-radius: 5px;
	color: #ffffff;
	box-sizing: border-box;
	font-size: 14px;
}

.input label {
	margin-right: 10px;
	color: #ffffff;
}

.input span {
	margin-left: 5px;
}

select {
	width: 100%;
	height: 28px;
	background: #ffffff00;
	border: 1px solid #02aefa;
	border-radius: 5px;
	color: #ffffff;
	box-sizing: border-box;
	appearance: none;
	padding: 0 10px;
}

.chose {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.radio.horizontal {
	display: flex;
	align-items: center;
}

.radio label {
	display: flex;
	align-items: center;
	margin-right: 20px; /* 增加间距以便更好地分隔选项 */
	color: #ffffff;
}

.radio span {
	margin-left: 5px;
	font-size: 14px;
}

.radio input {
	width: 16px;
	height: 16px;
}

.apply {
	width: 150px;
	height: 40px;
	/* height: auto; */
	background-image: url("../assets/images/apply.png"); /* 替换为你的背景图片路径 */
	background-size: cover;
	background-position: center;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin: auto;
	margin-top: 15px;
	color: #071beb;
	font-weight: bold;
}
.loading-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
}
.custom-select {
	appearance: none; /* 移除默认样式 */
	-webkit-appearance: none; /* Safari 和 Chrome */
	-moz-appearance: none; /* Firefox */
	background: url("../assets/images/dropdown-icon.png") no-repeat right 10px
		center; /* 替换为你的图标路径 */
	background-size: 12px; /* 根据图标大小调整 */
	padding-right: 30px; /* 为图标留出更多空间 */
	border: 1px solid #02aefa;
	border-radius: 4px;
	width: 100%;
	box-sizing: border-box;
	padding: 0 8px; /* 添加内边距以确保文本和图标不重叠 */
}
.custom-select option[value=""] {
	color: #999; /* placeholder颜色 */
}
.return {
	color: #fff;
	padding: 10px;
	border-radius: 5px;
	cursor: pointer;
}
</style>
